var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99659 0.655273C16.2151 0.655273 19.8425 3.79533 19.8425 10.5012C19.8425 17.2071 16.2151 20.3415 9.99659 20.3415C3.7781 20.3415 0.15625 17.2071 0.15625 10.5012C0.15625 3.79533 3.7781 0.655273 9.99659 0.655273ZM9.99659 19.1119C15.7949 19.1119 18.6128 16.2939 18.6128 10.5012C18.6128 4.70289 15.7949 1.88497 9.99659 1.88497C4.20387 1.88497 1.38594 4.70289 1.38594 10.5012C1.38594 16.2939 4.20387 19.1119 9.99659 19.1119ZM13.4644 13.3668L10.6156 10.5152L10.6184 6.66928C10.6184 6.32754 10.3439 6.05303 10.0022 6.05303C9.66045 6.05303 9.38594 6.33034 9.38594 6.66928V10.7701C9.38594 10.9326 9.45037 11.0894 9.56521 11.2043L12.6268 14.2659C12.8733 14.4984 13.2627 14.4844 13.4952 14.2351C13.7277 13.9886 13.7137 13.5993 13.4644 13.3668Z",
    fill: "#0B2739"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.23325ea367668a1cd65c2dd27931552e.svg";
export { ForwardRef as ReactComponent };